"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Star, User } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const posts = [{
    name: "Al K.",
    role: "Patient for 8 years",
    avatar: "/react-current/images/site/patient_robert.webp",
    quote: "They are the best and all the staff is so congenial. My wife and I have been patients for 8 years and we love Dr. Carrillo. Thanks, Florida Premier Cardiology."
  }, {
    name: "Mark B.",
    role: "Delray Medical Center",
    avatar: "/react-current/images/site/patient_sarah.webp",
    quote: "Dr. Carrillo has been my cardiologist for the past year at Delray Medical Center. He is an excellent, bright doctor and is extremely patient doctor. Answering all my concerns and questions. I find him thorough, caring and extremely knowledgeable."
  }, {
    name: "Ed R.",
    role: "Verified Patient",
    avatar: "/react-current/images/site/patient_thomas.webp",
    quote: "I found Dr. Carrillo to be very friendly, courteous and attentive. A true professional in his career, well-educated and knowledgeable."
  }];
  return <section data-section-id="1117" id="what-our-patients-say" className="relative overflow-hidden bg-slate-950 text-white py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-[1440px] mx-auto">
        <div ref={headRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-16 md:mb-24 transition-all duration-700 ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-8">
            <div className="inline-block font-default text-xs md:text-sm font-medium uppercase tracking-widest text-red-500 border border-red-500/20 px-4 py-2 mb-8 bg-red-500/5 rounded-md">
              Patient Experiences
            </div>
            <h2 className="font-default text-white leading-[1.1] tracking-tighter font-bold" style={{
            fontSize: "clamp(2.5rem, 5vw, 4rem)"
          }}>
              Trusted Cardiovascular Care in <span className="text-red-500">South Florida</span>
            </h2>
          </div>

          <div className="lg:col-span-4 flex flex-col justify-end items-start lg:items-end">
            <p className="text-slate-400 font-default text-lg">
              Read what our patients say about their experience with Dr. Carrillo-Jimenez.
            </p>
          </div>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((post, i) => <div key={i} className={`transition-all duration-700`} style={{
          transitionDelay: `${i * 120}ms`,
          opacity: gridVisible ? 1 : 0,
          transform: gridVisible ? "translateY(0)" : "translateY(24px)"
        }}>
              <Card className="relative bg-slate-900 border border-slate-800 rounded-lg p-8 hover:border-red-500/50 transition-all duration-300 shadow-lg">
                <div className="flex items-center gap-4 mb-6">
                  <SafeHydrate><Avatar className="size-14 border border-slate-700">
                    <AvatarImage src={post.avatar} alt={post.name} />
                    <AvatarFallback className="bg-slate-800 text-white">
                      <User className="size-6" />
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div>
                    <div className="font-default font-semibold text-white text-lg">
                      {post.name}
                    </div>
                    <div className="text-sm text-slate-400 font-default">
                      {post.role}
                    </div>
                  </div>
                </div>

                <div className="flex text-red-500 mb-4 gap-1">
                  {[...Array(5)].map((_, i) => <Star key={i} className="size-5 fill-red-500" />)}
                </div>

                <p className="text-slate-300 mb-8 font-default text-lg leading-relaxed">
                  "{post.quote}"
                </p>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}
